import type { KhoanChiTieu as IKhoanChiTieu } from '@/services/KhoanChiTieu';
import {
  getHoaDonMuaHang,
  getKhoanChiTieu,
  getLuongThang,
  getSoTienChiGiaoVien,
  getHangMucChi
} from '@/services/KhoanChiTieu/khoanchitieu';
import { useState } from 'react';

export default () => {
  const [danhSach, setDanhSach] = useState<IKhoanChiTieu.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<IKhoanChiTieu.Record>({} as any);
  const [totalChiTieu, setTotalChiTieu] = useState<number>(1);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>();
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [dataChiCoGiao, setDataChiCoGiao] = useState<IKhoanChiTieu.IDataChiCoGiao[]>([]);
  const [dataLuongThang, setDataLuongThang] = useState<IKhoanChiTieu.IDataLuong[]>([]);
  const [dataHoaDon, setDataHoaDon] = useState<IKhoanChiTieu.IDataHoaDon[]>([]);
  const [type, setType] = useState<'hoaDonMuaHang' | 'luongThang'>();
  const [totalChiPhi, setTotalChiPhi] = useState<any>();
  const [danhSachAll, setDanhSachAll] = useState<IKhoanChiTieu.Record[]>([]);
  const getKhoanChiTieuModel = async (donViId?: string, condition?: any) => {
    setLoading(true);
    if (condition) {
      // setCondition({...cond,...condition})
      const sort = { module: -1 };
      const khoanChi = await getKhoanChiTieu({ page: 1, limit: 1000, cond: {...condition, loaiDoanhThu: 'Khác'}, donViId, sort });
      const hangMucChi = await getHangMucChi({ page: 1, limit: 1000, cond: condition, donViId, sort });
      let rsHanMucChi = hangMucChi?.data?.data?.result.map((data: any) =>  {
        let tempData = { 
          ...data,
          ten: data.tenHangMuc,
          soTien: data.soTienThucTe,
          children: data.childrenList.length > 0 ? data.childrenList : null,
          key: data.id
        }
        delete tempData.childrenList
        return tempData;
      })
      let rsKhoanChi = khoanChi.data?.data?.result.map((data: any) => {
        let tempData = {
          ...data,
          loai: data.loaiDoanhThu,
          soTienDuKien: data?.soTienDuKien > 0 ? data.soTienDuKien : 0,
        }
        return tempData;
      })
      let resultAll = [...rsKhoanChi, ...rsHanMucChi]
      const resultPageable = resultAll?.length > limit ? getPageableResult(resultAll, page, limit) : resultAll;
      setDanhSachAll(resultAll ?? [])
      setDanhSach(resultPageable ?? []);
      setTotal((hangMucChi?.data?.data?.total + khoanChi?.data?.data?.total) ?? 0);
      setLoading(false);

      let totalKhoanChiTieu: number = 0;
      let totalSoTienDuKien = 0;
      let totalSoTienThucTe = 0;
      resultAll?.forEach((item: { soTien: number, soTienDuKien: number }) => {
        totalKhoanChiTieu += item?.soTien;
        totalSoTienDuKien += item?.soTienDuKien;
        totalSoTienThucTe += item?.soTien;
        return totalKhoanChiTieu;
      });
      setTotalChiTieu(totalKhoanChiTieu);
      const total = {
        "soTienDuKien": totalSoTienDuKien,
        "soTienThucTe": totalSoTienThucTe
      }
      setTotalChiPhi(total)
    }
  };
  const getDataTienChiGiaoVien = async (organizationId: string, thang: number, nam: number) => {
    const res = await getSoTienChiGiaoVien({
      donViId: organizationId as string,
      page: page,
      limit: limit,
      cond: { thang: thang, nam: nam },
    });
    if (res) {
      setDataChiCoGiao(res?.data?.data.result);
    }
  };
  const getPageableResult = (resultAll: any[], page: number, limit: number) => {
    if (!resultAll || resultAll.length === 0) return [];
  
    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
  
    return resultAll.slice(startIndex, endIndex);
  };
  
  const getLuongThangModel = async (
    thang: number,
    nam: number,
    donViId?: string,
    condition?: any,
  ) => {
    setLoading(true);
    const response = await getLuongThang({ thang, nam, cond:condition, donViId });
    setLoading(false);
    setDataLuongThang(response?.data?.data);
  };
  const getHoaDonModel = async (thang: number, nam: number, donViId?: string, condition?: any) => {
    setLoading(true);
    const response = await getHoaDonMuaHang({ thang, nam, cond:condition, donViId });
    setLoading(false);
    setDataHoaDon(response?.data?.data);
  };
  return {
    danhSach,
    totalChiPhi,
    record,
    setRecord,
    loading,
    setLoading,
    total,
    setTotal,
    page,
    limit,
    setPage,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    getKhoanChiTieuModel,
    setVisibleForm,
    visibleForm,
    edit,
    setEdit,
    totalChiTieu,
    dataChiCoGiao,
    getDataTienChiGiaoVien,
    getHoaDonModel,
    getLuongThangModel,
    dataLuongThang,
    dataHoaDon,
    type,
    setType,
    danhSachAll,
  };
};
